var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1445 11.2988C22.1445 13.2564 21.6551 15.0679 20.6763 16.7334C19.6975 18.3988 18.3754 19.7209 16.7099 20.6997C15.0445 21.6785 13.233 22.1679 11.2754 22.1679C9.31777 22.1679 7.50625 21.6785 5.84081 20.6997C4.17538 19.7209 2.85326 18.3988 1.87446 16.7334C0.895653 15.0679 0.40625 13.2564 0.40625 11.2988C0.40625 9.3412 0.895653 7.52968 1.87446 5.86425C2.85326 4.19882 4.17538 2.8767 5.84081 1.8979C7.50625 0.919091 9.31777 0.429688 11.2754 0.429688C13.233 0.429688 15.0445 0.919091 16.7099 1.8979C18.3754 2.8767 19.6975 4.19882 20.6763 5.86425C21.6551 7.52968 22.1445 9.3412 22.1445 11.2988ZM10.0445 17.1854L17.8567 8.81758C17.9982 8.69631 18.069 8.52956 18.069 8.31733C18.069 8.1051 17.9982 7.93835 17.8567 7.81708L16.9226 6.77109C16.7811 6.6195 16.6183 6.54371 16.4344 6.54371C16.2504 6.54371 16.0876 6.6195 15.9461 6.77109L9.57748 13.5927L6.60545 10.4093C6.46392 10.2577 6.30117 10.1819 6.11719 10.1819C5.9332 10.1819 5.77045 10.2577 5.62892 10.4093L4.69486 11.4553C4.55333 11.5766 4.48257 11.7433 4.48257 11.9555C4.48257 12.1678 4.55333 12.3345 4.69486 12.4558L9.11044 17.1854C9.22366 17.337 9.37934 17.4128 9.57748 17.4128C9.77561 17.4128 9.93129 17.337 10.0445 17.1854Z",
    fill: "#0FBC71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkCircle);
export default __webpack_public_path__ + "static/media/CheckmarkCircle.6029971d8705e354c9475ab1c6be6cd5.svg";
export { ForwardRef as ReactComponent };